import moment from "moment"

export const formatedDate = (date, format = `MMMM Do YYYY`) => {
  let dateObject = moment(date)
  return dateObject.format(format)
}
